/*
 * Copyright (c) 2023, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

import React, {useState} from 'react'
import PropTypes from 'prop-types'
import {useIntl} from 'react-intl'

// Components
import {
    Box,
    Container,
    Flex,
    Heading,
    SimpleGrid,
    Stack,
    useMultiStyleConfig,

    // Hooks
    useTheme
} from '@salesforce/retail-react-app/app/components/shared/ui'

// Project Components
import LinksList from './links-list'
// import LinksList from '../../components/links-list'
// import LinksList from '@salesforce/retail-react-app/app/components/links-list'

// Others
import {categoryUrlBuilder} from '../../utills/url'
import {ChevronRightIcon} from '../icons'
import Link from '@salesforce/retail-react-app/app/components/link'
import {pxToRem} from '../../utills/pxToRem'

const ListMenuMainContent = ({
    item,
    setLinksForContentComp,
    itemsKey,
    onClose,
    initialFocusRef,
    setfeatureImage,
    setSelectedLevelOneMenu,
    setLinksForLevelTwoMenu,
    setIsLevelTwoMenuOpen,
    isLevelTwoMenuOpen,
    isLevelThreeMenuOpen,
    isMobileMenu = false,
    setFeatureImageMobileLevelTwo,
    setFeatureImageMobileLevelThree,
    setFeatureImageMobileLevelFour
}) => {
    const theme = useTheme()
    const {baseStyle} = theme.components.ListMenu
    const {locale} = useIntl()
    const items = item?.[itemsKey] || []

    const variant = 'vertical'

    const styles = useMultiStyleConfig('LinksList', {variant})

    return (
        <>
            <Container
                as={Stack}
                {...baseStyle.popoverContainer}
                position={'relative'}
                sx={{margin: 0, padding: 0}}
            >
                <Flex direction="column" flex={'1'} gap={pxToRem(30)}>
                    {/* level category menu items */}
                    {items.map((item, index) => {
                        const {
                            id,
                            name,
                            c_headerMenuBanner,
                            c_alternativeUrl = '',
                            c_categoryTextColor,
                            c_categoryIcon,
                            c_categoryIconPosition
                        } = item
                        const items = item[itemsKey]
                        const heading = {
                            id: id,
                            image: c_headerMenuBanner,
                            c_alternativeUrl: c_alternativeUrl,
                            href: categoryUrlBuilder(item, locale),
                            text: name,
                            c_categoryTextColor,
                            c_categoryIcon,
                            c_categoryIconPosition,
                            styles: {
                                fontSize: 'md',
                                marginBottom: 2
                            }
                        }

                        const links = items
                            ? items.map((item) => {
                                  const {name, id, categories} = item
                                  return {
                                      id: id,
                                      categories: categories,
                                      name: name,
                                      href: categoryUrlBuilder(item, locale),
                                      text: name,
                                      styles: {
                                          fontSize: 'md',
                                          paddingTop: 3,
                                          paddingBottom: 3
                                      }
                                  }
                              })
                            : []

                        return (
                            <LinksList
                                key={id}
                                isMainContent={true}
                                isMobileMenu={isMobileMenu}
                                categoryData={item}
                                hasSubMenu={item?.categories ? true : false}
                                heading={heading}
                                links={links}
                                color={'gray.900'}
                                onLinkClick={onClose}
                                {...(index === 0 ? {headingLinkRef: initialFocusRef} : {})}
                                setfeatureImage={setfeatureImage}
                                setSelectedLevelOneMenu={setSelectedLevelOneMenu}
                                setLinksForLevelTwoMenu={setLinksForLevelTwoMenu}
                                setIsLevelTwoMenuOpen={setIsLevelTwoMenuOpen}
                                setLinksForContentComp={setLinksForContentComp}
                                setFeatureImageMobileLevelTwo={setFeatureImageMobileLevelTwo}
                                setFeatureImageMobileLevelThree={setFeatureImageMobileLevelThree}
                                setFeatureImageMobileLevelFour={setFeatureImageMobileLevelFour}
                            />
                        )
                    })}
                </Flex>
            </Container>
        </>
    )
}

ListMenuMainContent.propTypes = {
    item: PropTypes.object,
    itemsKey: PropTypes.string,
    onClose: PropTypes.func,
    initialFocusRef: PropTypes.object,
    setfeatureImage: PropTypes.func,
    setSelectedLevelOneMenu: PropTypes.object,
    setLinksForLevelTwoMenu: PropTypes.array,
    setIsLevelThreeMenuOpen: PropTypes.func,
    setIsLevelTwoMenuOpen: PropTypes.func,
    setLinksForContentComp: PropTypes.func,
    isMobileMenu: PropTypes.oneOf[(true, false)],
    setFeatureImageMobileLevelTwo: PropTypes.func,
    setFeatureImageMobileLevelThree: PropTypes.func,
    setFeatureImageMobileLevelFour: PropTypes.func,
    isLevelTwoMenuOpen: PropTypes.bool,
    isLevelThreeMenuOpen: PropTypes.bool
}

export {ListMenuMainContent}
